<div class="wrapper__headerComponent container my-1">
  <div class="row">
    <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2">
      <img
        src="../../../../assets/img/file-alt.svg"
        alt="logo"
        class="img-ico-form imagen" />
      <h2 class="mb-0">{{ configurarText['administar-cuenta'] }}</h2>
    </div>
  </div>
</div>
<div class="container mb-3">
  <div
    class="d-flex flex-column flex-md-row align-items-start justify-content-start mt-5 gap-3 card__profile">
    <div
      class="border__form rounded px-3 py-4 flex-shrink-0 card__profile__left">
      <div class="d-flex flex-column align-items-center gap-3">
        <img src="https://ui-avatars.com/api/?background=b5c7e9&name={{
            getInicialesNombreUsuario()
          }}&size=200&rounded=true&color=0943b5" alt="" />
        <div class="d-flex flex-column gap-2">
          <h5 *ngIf="getNombreUsuario()">{{ getNombreUsuario() }}</h5>
          <div class="d-flex flex-row align-items-center gap-2">
            <span class="govco-svg govco-address-card"></span>
            <p class="mb-0 form-label text3-tipografia-govco mb-0">
              {{ getNumeroDocumento() }}
            </p>
          </div>
          <div class="d-flex flex-row align-items-center gap-2">
            <span class="govco-svg govco-folder-user"></span>
            <p class="mb-0 form-label text3-tipografia-govco mb-0">
              {{ getTipoUsuario() }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="border__form rounded px-3 py-4 flex-grow-1 info-cuenta">
      <div class="d-flex flex-column align-items-start gap-3">
        <h4>{{ configurarText['preferencias'] }}</h4>
        <form [formGroup]="preferenciasForm">
          <!--<div class="col-12 col-xl-12 mb-1">
            <h4 class="text-left h5-tipografia-govco">
              Autenticación de doble factor:
            </h4>
             <div class="form-row required form-label">
              <div class="text2-tipografia-govco me-3">
                Dirección de correo de verificación:
              </div>
              <div class="d-flex align-items-center">
                <strong
                  *ngIf="!editandoCorreo"
                  class="ms-2 text2-tipografia-govco">
                  {{ preferenciasForm.get('email')?.value }}
                </strong>

                <div *ngIf="editandoCorreo" class="w-100 mx-2">
                  <input
                    formControlName="email"
                    class="form-control ms-2"
                    type="email"
                    [ngClass]="{
            'is-invalid': validateField(preferenciasForm, 'email'),
          }" />
                  <div
                    *ngIf="
            preferenciasForm.get('email')?.invalid &&
            preferenciasForm.get('email')?.touched
          "
                    class="invalid-feedback d-block">
                    <div
                      *ngIf="preferenciasForm.get('email')?.hasError('required')">
                      El campo de correo es obligatorio.
                    </div>
                    <div
                      *ngIf="preferenciasForm.get('email')?.hasError('pattern')">
                      El formato del correo es inválido.
                    </div>
                    <div
                      *ngIf="
              preferenciasForm.get('email')?.hasError('maxlength')
            ">
                      El correo no puede superar los 100 caracteres.
                    </div>
                  </div>
                </div>
                <div class="mx-1">
                  <button
                    class="btn hvr-shrink"
                    (click)="editarCorreo()"
                    *ngIf="!editandoCorreo">
                    <i class="govco-edit" title="Modificar correo de verificación">
                      Modificar correo de verificación
                    </i>
                  </button>
                  <button
                    class="btn hvr-shrink"
                    (click)="guardarCorreo()"
                    *ngIf="editandoCorreo"
                    [disabled]="preferenciasForm.invalid">
                    <i class="govco-save" title="Guardar correo de verificación">
                      Guardar correo de verificación
                    </i>
                  </button>
                </div>
              </div>
            </div> 
          </div>-->
          <div class="col-12 col-xl-12 mb-1">
            <h4 class="text-left h5-tipografia-govco">
              {{ configurarText['recibir-notificaciones'] }}
            </h4>
            <div
              *ngIf="esUsuarioAdministrador()"
              class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-6">
              <div class="form-check mt-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="true"
                  formControlName="recibirNotificacionesCorreo" />
                <label
                  class="form-check-label text2-tipografia-govco"
                  for="flexCheckDefault">
                  {{ configurarText['notificar'] }}
                </label>
              </div>
            </div>
            <div
              *ngIf="!esUsuarioAdministrador()"
              class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-6">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="true"
                  formControlName="informesMensual" />
                <label
                  class="form-check-label text2-tipografia-govco"
                  for="flexCheckDefault">
                  {{ configurarText['informes'] }}
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="true"
                  formControlName="alertasMetricas" />
                <label
                  class="form-check-label text2-tipografia-govco"
                  for="flexCheckDefault">
                  {{ configurarText['alertas'] }}
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div
        class="d-flex flex-column flex-md-row justify-content-end my-2 gap-2 mt-2 mt-md-5">
        <button
          type="button"
          class="btn-govco outline-btn-govco hvr-shrink"
          (click)="enviarMensajeCambiarContrasena()"
          [attr.aria-label]="configurarText['cambiar-contrasenia']">
          {{ configurarText['cambiar-contrasenia'] }}
        </button>
        <button
          type="submit"
          class="btn-govco fill-btn-govco hvr-shrink"
          (click)="guardar()"
          [disabled]="preferenciasForm.invalid || preferenciasForm.pristine"
          aria-label="Guardar cambios">
          {{ configurarText['guardar'] }}
        </button>
      </div>
    </div>
  </div>
</div>
